import axiosInstance from "./axiosInstance";

// Submit user form (with image upload)
export const submitUserForm = async (formData) => {
  try {
    const response = await axiosInstance.post("/users/submit", formData, {
      headers: {
        "Content-Type": "multipart/form-data", // required for file upload
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Get all users
export const getAllUsers = async () => {
  try {
    const response = await axiosInstance.get("/users/all");
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
